(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();

document.addEventListener('click', function (e) {
  document.querySelectorAll('.share-dropdown').forEach(function (dropdown) {
    const toggle = dropdown.querySelector('.share-toggle');

    if (toggle.contains(e.target)) {
      dropdown.classList.toggle('active');
    } else if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('active');
    }
  });
});

// Copy link: handled by copy.js (uses window.location.href). Do not duplicate here —
// a delegated listener without data-copy-url was overwriting the clipboard with null.

// Preserve cart icon when variant changes
(function() {
  let iconTemplate = null;

  // Store the original icon template on page load
  const storeIconTemplate = () => {
    const submitButton = document.querySelector('.product-form__submit');
    if (!submitButton) return;

    const buttonSpan = submitButton.querySelector('span');
    if (!buttonSpan) return;

    const icon = buttonSpan.querySelector('svg, .icon-cart, [class*="icon"]');
    if (icon && !iconTemplate) {
      iconTemplate = icon.cloneNode(true);
    }
  };

  const preserveCartIcon = () => {
    const submitButton = document.querySelector('.product-form__submit');
    if (!submitButton) return;

    const buttonSpan = submitButton.querySelector('span');
    if (!buttonSpan) return;

    // Check if icon already exists
    const existingIcon = buttonSpan.querySelector('svg, .icon-cart, [class*="icon"]');
    if (existingIcon) return;

    // Use stored template or try to find one
    if (iconTemplate) {
      const iconClone = iconTemplate.cloneNode(true);
      buttonSpan.appendChild(iconClone);
    } else {
      // Try to find icon in the document
      const iconInDoc = document.querySelector('.product-form__submit span svg, .product-form__submit span .icon-cart');
      if (iconInDoc) {
        iconTemplate = iconInDoc.cloneNode(true);
        const iconClone = iconTemplate.cloneNode(true);
        buttonSpan.appendChild(iconClone);
      }
    }
  };

  // Store icon template on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', storeIconTemplate);
  } else {
    storeIconTemplate();
  }

  // Listen for variant change events
  document.addEventListener('change', function(e) {
    if (e.target.closest('variant-radios, variant-selects, .product-parameters')) {
      setTimeout(preserveCartIcon, 100);
    }
  });

  // Also listen for custom variant update events
  document.addEventListener('variant:change', preserveCartIcon);
  document.addEventListener('variantChange', preserveCartIcon);

  // Use MutationObserver to watch for button content changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const submitButton = document.querySelector('.product-form__submit');
        if (submitButton && (mutation.target === submitButton || mutation.target.closest('.product-form__submit'))) {
          setTimeout(preserveCartIcon, 50);
        }
      }
    });
  });

  // Observe the product form area
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    observer.observe(productForm, {
      childList: true,
      subtree: true
    });
  }

  // Initial check after a delay
  setTimeout(() => {
    storeIconTemplate();
    preserveCartIcon();
  }, 500);
})();

